import { render, staticRenderFns } from "./CustomFieldAddressSection.vue?vue&type=template&id=226532d0&"
import script from "./CustomFieldAddressSection.vue?vue&type=script&lang=js&"
export * from "./CustomFieldAddressSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports